import { gql } from '@apollo/client';

export const GET_MEMBER_USER = gql`
  query memberUser($id: ID!) {
    memberUser(id: $id) {
      id
      applications {
        id
        uuid
        state
        programUuid
        academicPartnerUuid
        userId
      }
      coachingLinks {
        growthCoachingLink
      }
    }
  }
`;
